module.exports = __webpack_public_path__ + "img/slide-2.afde029.webp";